export default __webpack_public_path__ + "static/media/anc.7fe5df78.jpg";